import { Controller } from 'stimulus';
import gsap from 'gsap';
import jump from 'jump.js';
import timeoutPromise from '../helpers/timeoutPromise';
import mapInputOutput from '../helpers/mapInputOutput';

class SharedHeader extends Controller {
  // eslint-disable-next-line class-methods-use-this
  connect() {
    this.isAnimatingHeader = true;

    this.calculateOffsets();

    this.hideHeader();

    timeoutPromise(1000).then(this.animateHeader.bind(this));
  }

  onWindowResize() {
    this.calculateOffsets();
  }

  onWindowLoad() {
    this.calculateOffsets();
  }

  onCountClick() {
    jump(this.element.offsetHeight - 80);
  }

  calculateOffsets() {
    this.windowWidth = window.innerWidth;
    this.headerHeight = this.element.offsetHeight;
  }

  onWindowScroll() {
    if (this.isAnimatingHeader) {
      return;
    }

    const scrollStart = this.headerHeight / 3.5;
    const scrollAnimationDuration = this.windowWidth > 1680 ? 200 : 100;
    const scrollEnd = scrollStart + scrollAnimationDuration;

    let progress = mapInputOutput(window.scrollY, scrollStart, scrollEnd, 0, 1);

    if (progress < 0) {
      progress = 0;
    } else if (progress > 1) {
      progress = 1;
    }

    if (this.hasIllustrationsTarget) {
      gsap.to(this.illustrationsTarget, {
        opacity: 1 - progress,
        ease: 'none',
        duration: 0.1,
      });
    }

    gsap.to(this.headerContentTarget, {
      opacity: 1 - progress,
      ease: 'none',
      duration: 0.1,
    });
  }

  hideHeader() {
    this.headerContentTarget.style.opacity = 0;

    if (this.hasIllustrationsTarget) {
      this.illustrationsTarget.style.opacity = 0;
    }

    // We've hidden all items we're going to animate, so we can show the wrapper...
    this.element.style.opacity = 1;
  }

  animateHeader() {
    gsap.fromTo(this.headerContentTarget, {
      opacity: 0,
      y: -30,
    }, {
      opacity: 1,
      y: 0,
      duration: 2,
      ease: 'power2.out',
      onComplete: () => {
        this.isAnimatingHeader = false;
        this.onWindowScroll();
      },
    });

    if (this.hasIllustrationsTarget) {
      gsap.fromTo(this.illustrationsTarget, {
        opacity: 0,
        y: 30,
      }, {
        opacity: 1,
        y: 0,
        duration: 2,
        ease: 'power2.out',
        delay: 0.25,
      });
    }
  }
}

SharedHeader.targets = [
  'headerContent',
  'illustrations',
];

export default SharedHeader;
